
import React,
{
  useCallback,
  useMemo
} from 'react'
import { useQuery } from 'react-query'

import { Input } from '@driftt/tide-core'
import { getDuplicates } from 'api/contacts'
import DuplicatesListActionMenu from 'components/DuplicatesListActionMenu'
import ObjectList from 'components/ObjectList'
import { useContactProperties } from 'hooks/useContactProperties'
import { useQueryStringState } from 'hooks/useQueryStringState'
import ObjectListLayout from 'layouts/ObjectList'
import { resolvePropertyValue } from 'utils/contactProperties'

import './style.css'

const DuplicatesList = () => {
  const [candidatesParams, setCandidatesParams] = useQueryStringState({
    size: 25,
    from: 0,
    sortField: 'latest_dup',
    sortAscended: false,
    q: null
  })

  const [contactProperties] = useContactProperties()
  const propertyResolver = useMemo(() => resolvePropertyValue(contactProperties), [contactProperties])

  const {
    isFetching,
    error,
    data
  } = useQuery(['merge-candidates', candidatesParams],
    () => (
      getDuplicates(candidatesParams)
        .then(({ data }) => data)
    ), { keepPreviousData: true })

  const searchTable = useCallback((event) => {
    event.persist()

    const value = event.target.value.length
      ? event.target.value
      : null

    setCandidatesParams(draft => {
      draft.q = value
    })
  }, [setCandidatesParams])

  return (
    <ObjectListLayout
      title='Merge contacts'
      breadcrumbs={[{
        title: 'Contacts',
        link: '/contacts'
      }, {
        title: 'Duplicates',
        link: '/contacts/duplicates'
      }]}
    >
      <div className='crm-duplicates-list'>
        {!(isFetching && !data?.total) && <p>{`${data?.total ?? '--'} sets of potential duplicates`}</p>}
        <Input
          className="crm-duplicates-list-search"
          type="search"
          onChange={searchTable}
        />
        <ObjectList
          isLoading={isFetching}
          error={error}
          setParams={setCandidatesParams}
          params={candidatesParams}
          data={data}
          selectedColumns={[{
            label: 'Email',
            value: 'email',
            className: 'crm-duplicates-list-column-header crm-duplicates-list-name-column',
            customKey: `crm-column-name-primary`,
            width: '220px'
          },{
            value: 'name',
            label: 'Name',
            className: 'crm-duplicates-list-column-header '
          }, {
            value: 'latest_dup',
            label: 'Last active',
            className: 'crm-duplicates-list-column-header'
          }, {
            value: 'dup_count',
            label: 'Contacts',
            className: 'crm-duplicates-list-column-header crm-duplicates-list-num-of-dupes-column'
          }]}
          propertyResolver={(property, record) => {
            return propertyResolver(property, record)
          }}
          actionColumn={{
            row: {
              content: rowRecord => <DuplicatesListActionMenu candidate={rowRecord} />,
              className: 'crm-duplicates-list-action-cell'
            },
            column: {
              label: (
                ""
              ),
              className: 'crm-duplicates-list-action-header',
              customKey: `crm-action-column`,
              value: null,
              sortable: false,
              width: '30px',
            }
          }}
          primaryColumns={[]}
        />
      </div>
    </ObjectListLayout>
  )
}

export default DuplicatesList
